import React from "react";

import { getGroups, getGroupsKey } from "modules/groups/api/getGroups";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { useReactQuery } from "components/RemoteData";
import { ChakraText } from "components/ChakraText";

interface IProps {
  groupId: string;
}

const GroupName = ({ groupId }: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const { data: groupList } = useReactQuery(getGroupsKey(), () =>
    getGroups(friendlyUrl)
  );

  const selectedGroup = groupList?.find((group) => groupId === group.id);

  return <ChakraText>{selectedGroup?.name}</ChakraText>;
};

export { GroupName };
